/*eslint-disable */

import axios from 'axios';
import{ bus } from '@/main';
import root from '@/_helpers/roots';
import { toInteger } from 'lodash';
import toast from '@/services/toast';

var $ = window.jQuery = require('jquery');
let conferenceInfoApiUrl = root.conferenceInfoApiUrl.link;
export default {
  name: 'user-info-for-conference',
  components: {
  },
  props: ['meetingID'],
  data () {
    return {
      submitted:false,
      first_name:'',
      last_name:'',
      email:'',
      organisation:'',
      phone: {
        number: '',
        isValid: false,
        countryIso: '',
        countryCode:''
      },
      accept_txt:false,
      clientIP:'',
      meetingStatusData:null,
      meetingStatusFlag:Boolean,
      idInvalidStatus:false,
      maxCapcityState:false,
      getRouteName:null,
      userJoinedCount:0
    }
  },
  computed: {
  },
  mounted () {
    this.getRouteName = this.$route.name
    this.getUserCountry();
    if(this.$route.hash){
      this.$store.dispatch('getPubMeetingStatusAction', {id:location.hash.substring(1)}).then((res) => {
        this.meetingStatusData = res.data.data
        this.meetingStatusFlag = this.meetingStatusData.is_pubilc_meeting
        this.userJoinedCount = this.meetingStatusData.count
        if(this.userJoinedCount > 40){
          this.maxCapcityState = true
        }
        // if(this.meetingStatusData.length > 0){
        //   this.meetingStatusFlag = this.meetingStatusData[0].is_pubilc_meeting
        // }
      }).catch((err) => {
        this.idInvalidStatus = true
      })
    }
  },
  methods: {
    getUserCountry() {
      var _self = this
      fetch('https://ipapi.co/json/')
        .then(function(response) {
          return response.json();
        })
        .then(function(text) {
          _self.clientIP = text.ip
        })
        .catch(function(error) {
          console.log('Request failed', error)
        });
    },
    sendUserInfoSubmitMethod(){
      this.$validator.validateAll().then((result) => {
        if(result){
          this.submitted =  true
          let payload = {
            name: this.first_name + ' ' + this.last_name,
            email: this.email,
            ip_add:this.clientIP,
            meeting_id:this.meetingID
          }
          axios.post(conferenceInfoApiUrl, payload).then(res => {
            this.submitted =  false
            bus.$emit('meetingStartAlert', payload);
            this.closeStoreInfoPopup()
          }).catch(err => {
            toast.error(err.data.data || err.data.user_msg || err.data.msg);
            this.submitted =  false
          })
          return;
        }
      })
    },
    closeStoreInfoPopup(){
      $('body').removeClass('body_right_scroll_remove')
      bus.$emit('userInfoStoreBus', false);
    },
  },
}